module.exports = __webpack_public_path__ + "img/loja-fisica-branco.daa4893e.png";